import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { Button } from "../ui/button";

const LanguageButton = () => {
  // ============== Use Hook ==============
  const { i18n } = useTranslation();

  // ============== Use Effect ==============
  useEffect(() => {
    document.documentElement.setAttribute("dir", i18n.dir());
  }, [i18n.language, i18n]);

  // ============= Toggle Function ==============
  const toggleLanguage = () => {
    const newLanguage = i18n.language === "en" ? "fa" : "en";
    i18n.changeLanguage(newLanguage);
  };

  // ============= Rendering ==============
  return (
    <Button
      onClick={toggleLanguage}
      variant={"ghost"}
      title="Toggle language"
      size={"sm"}
    >
      {i18n.language === "fa" ? "EN" : "فا"}
    </Button>
  );
};

export default LanguageButton;
